import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";
import { noop } from "rxjs";

@Component({
  selector: "form-checkbox",
  templateUrl: "./checkbox.component.html",
  styleUrls: ["./checkbox.component.scss"],
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  private static ID: number = 0;
  public id: number;
  @Input() public focus = false;
  @Input() public disabled = "false";
  @Input() public small = false;

  @Input() public value!: any;
  @Output() public valueChange = new EventEmitter<any>();

  constructor() {
    this.id = CheckboxComponent.ID++;
  }

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  writeValue(value: any) {
    if (value !== this.value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onChange() {
    this.onTouchedCallback();
    this.onChangeCallback(this.value);
  }

  ngOnInit(): void {}
}
